import React, { useEffect, useState } from 'react';
import Seo from '../../../Components/SeoComponent/Seo';
import Header from '../../../Components/Header';
import { Button, InputWithLabel } from '../../../Components/Tags/Tags';
import Loader from '../../../Loader';
import { advanceUpiCheckService, BankAccountAnlyscisService, BankAccountAnlyscisServiceUpload, fetchProfile, itrComplinceCheckService } from '../../../Services/ApiTestService/aadharTestService';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import {
    FaPrint,
    FaCopy,
    FaUser,
} from "react-icons/fa"
import { Bankstatement } from '../Data';
import { useService } from '../../../context/ServiceContext';



const BankAccountAnlyscis = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [statementFile, setStatementFile] = useState(null);
    const [message, setMessage] = useState({ message: "", type: "error" });
    const [profileData, setProfileData] = useState({});
    const [statementData, setStateMentData] = useState(null);
    const [isVerify, setIsVerify] = useState(false);
    const [clientId, setClientId] = useState('');
    const { serviceName } = useService();
    async function handleSubmit() {


        if (statementFile === null) {
            setMessage({ message: "File  is required required.", type: "error" });
            return;
        }

        try {
            setMessage({ message: "Verifying Upi Id...", type: "success" });
            const formData = new FormData();
            formData.append('api_id', profileData?.user_id);
            formData.append('api_key', profileData?.api_key);
            formData.append('token_id', profileData?.token_id);
            formData.append('file', statementFile);
            formData.append('methodName', "upload");
            let response = {};
          //  return;
            setIsLoading(true);
            if (isVerify === true) {
                let payload = {
                    api_id: profileData?.user_id,
                    api_key: profileData?.api_key,
                    token_id: profileData?.token_id,
                    client_id: clientId,
                    methodName: "download"
                }
                response = await BankAccountAnlyscisService({ payload: payload });
            } else {
                response = await BankAccountAnlyscisServiceUpload( formData );
            }

            if (response.status.code === 200) {
                setIsLoading(false);
                showSuccessToast(response.message);
                setMessage({ message: "", type: "" });
                //setStateMentData(response.data);
                if (isVerify === false) {
                    setClientId(response.data.client_id);
                    setIsVerify(true);

                } else {
                    setClientId('');
                    // setStateMentData(response.data)
                    setStateMentData(Bankstatement.data)
                }

            } else {
                setIsLoading(false);

                showErrorToast(response.message || response.data.message || response.error.message || "Something went wrong.");
                setMessage({ message: "Something went wrong. Please try again.", type: "error" });
            }

        } catch (error) {
            setIsLoading(false);
            setMessage({ message: "Something went wrong. Please try again.", type: "error" });
           // console.log('something went wrong', error);
        }
    }

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setIsLoading(true);
                const response = await fetchProfile();
                setProfileData(response.data);
            } catch (error) {
                console.error("Error fetching profile data:", error);
                showErrorToast("Failed to fetch profile data.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfileData();
    }, []);




    const renderCompanyCard = () => {
        const handlePrint = (id) => {
         //   console.log(`Printing: ${id}`);
        };

        const getValue = (data, key, defaultValue = "Not Available") => {
            return data && data[key] ? data[key] : defaultValue;
        };


        const renderFraudCheckTriggers = (triggers) => {
            return triggers && triggers.length > 0 ? (
                triggers.map((trigger, index) => (
                    <div key={index} className="mb-2">
                        <p><strong>{trigger["Possible Fraud Indicators"]}:</strong> {getValue(trigger, "Identified?", "Not Identified")}</p>
                    </div>
                ))
            ) : (
                <p>No fraud check triggers available.</p>
            );
        };


        const renderFraudCheckDetails = (details) => {
            return details && details.length > 0 ? (
                details.map((detail, index) => (
                    <div key={index} className="border-t border-gray-300 mt-2 pt-2">
                        <p><strong>{getValue(detail, "FCU Trigger", "No Trigger")}</strong> | {getValue(detail, "Date", "No Date")}</p>
                        <p><strong>Amount:</strong> ${getValue(detail, "Amount", 0)}</p>
                        <p><strong>Balance:</strong> ${getValue(detail, "Balance", 0)}</p>
                    </div>
                ))
            ) : (
                <p>No fraud check details available.</p>
            );
        };


        const renderQuarterlyAverage = (averageData) => {
            return averageData && averageData.length > 0 ? (
                averageData.map((avg, index) => (
                    <div key={index} className="border-t border-gray-300 mt-2 pt-2">
                        <p><strong>Quarter:</strong> {avg["Quaters"]}</p>
                        <p><strong>Start Date:</strong> {avg["Quarter start"]}</p>
                        <p><strong>End Date:</strong> {avg["Quarter end"]}</p>
                        <p><strong>Average Balance:</strong> ${avg["Average Balance"]}</p>
                    </div>
                ))
            ) : (
                <p>No quarterly averages available.</p>
            );
        };


        const renderTransactions = (transactions) => {
            return transactions && transactions.length > 0 ? (
                transactions.map((transaction, index) => (
                    <div key={index} className="border-t border-gray-300 mt-2 pt-2">
                        <p><strong>{getValue(transaction, "Description", "No Description")}</strong></p>
                        <p><span>{getValue(transaction, "Credit/Debit", "Unknown")}</span> | <span>{`$${getValue(transaction, "Amount", 0)}`}</span></p>
                        <p>Balance: ${getValue(transaction, "Balance", 0)}</p>
                    </div>
                ))
            ) : (
                <p>No transactions available.</p>
            );
        };


        const renderScorecard = (scorecard) => {
            return scorecard && scorecard.length > 0 ? (
                scorecard.map((item, index) => (
                    <div key={index} className="border-t border-gray-300 mt-2 pt-2">
                        <p><strong>{item["Item"]}:</strong> {getValue(item, "Details", "Not Available")}</p>
                    </div>
                ))
            ) : (
                <p>No scorecard details available.</p>
            );
        };


        const renderMonthWiseDetails = (monthDetails) => {
            return monthDetails && monthDetails.length > 0 ? (
                monthDetails.map((detail, index) => (
                    <div key={index} className="border-t border-gray-300 mt-2 pt-2">
                        <p><strong>Month:</strong> {detail["Month"]}</p>
                        <p><strong>Total Credit:</strong> ${detail["Total Credit"]}</p>
                        <p><strong>Total Debit:</strong> ${detail["Total Debit"]}</p>
                        <p><strong>Monthly Surplus:</strong> ${detail["Monthly Surplus"]}</p>
                    </div>
                ))
            ) : (
                <p>No monthly details available.</p>
            );
        };

        return (
            <div id="company-cards" className="relative bg-white/80 backdrop-blur-lg border border-blue-200 p-6 rounded-2xl shadow-2xl max-w-2xl mx-auto transition-all duration-300 hover:shadow-3xl hover:scale-[1.01]">
                {/* Print Button */}
             
             
                <div className="col-span-2 md:col-span-6 flex justify-end">
  <Link
    to="/TestMaster"
    className="flex items-center gap-2 text-white bg-green-600 hover:bg-green-700 px-2 py-2 rounded-md font-semibold shadow-md transition duration-300"
  >
    <span>Go Back</span>
    <IoArrowBackCircleOutline size={24} />
  </Link>
</div>

             
             
                <div
                    onClick={() => handlePrint("company-cards")}
                    className="absolute top-4 right-0 w-10 h-10 bg-blue-700 rounded-full shadow-inner flex justify-center items-center cursor-pointer hover:bg-blue-500 transition-colors"
                >
                    <FaPrint className="text-white text-xl" />
                </div>


                <div className="mb-4 flex items-center gap-3">
                    <FaUser className="text-blue-700 text-2xl" />
                    <h2 className="text-2xl font-semibold text-blue-900">
                        {getValue(statementData.statement, 'full_name')}
                    </h2>
                </div>


                <div className="mt-4">
                    <h3 className="text-xl font-semibold text-blue-900 mb-2">Fraud Check Triggers:</h3>
                    {renderFraudCheckTriggers(getValue(statementData.statement, 'Fraud Check Triggers - Fraud Checks', []))}
                </div>


                <div className="mt-4">
                    <h3 className="text-xl font-semibold text-blue-900 mb-2">Fraud Check Details:</h3>
                    {renderFraudCheckDetails(getValue(statementData.statement, 'Fraud Check Triggers - Fraud Check Details', []))}
                </div>


                <div className="mt-4">
                    <h3 className="text-xl font-semibold text-blue-900 mb-2">Quarterly Average:</h3>
                    {renderQuarterlyAverage(getValue(statementData.statement, 'Quaterly Average', []))}
                </div>


                <div className="mt-4">
                    <h3 className="text-xl font-semibold text-blue-900 mb-2">Transactions:</h3>
                    {renderTransactions(getValue(statementData.statement, 'All Transactions', []))}
                </div>


                <div className="mt-4">
                    <h3 className="text-xl font-semibold text-blue-900 mb-2">Scorecard:</h3>
                    {renderScorecard(getValue(statementData.statement, 'Summary - Scorecard', []))}
                </div>


                <div className="mt-4">
                    <h3 className="text-xl font-semibold text-blue-900 mb-2">Monthly Details:</h3>
                    {renderMonthWiseDetails(getValue(statementData.statement, 'Month Wise Details', []))}
                </div>


            </div>
        );
    };



    function handleCopyText(data) {
        window.navigator.clipboard.writeText(JSON.stringify(data));
        showSuccessToast('Copied successfully')
    }






    return (
        <div className="p-4">
            <Seo title={serviceName} />
            <Header heading={serviceName} />
            {isLoading && <Loader />}

                  
                  <div className="col-span-2 md:col-span-6 flex justify-end">
              <Link
                to="/TestMaster"
                className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
              >
                <span>Go Back</span>
                <IoArrowBackCircleOutline size={24} />
              </Link>
            </div>

            <div className='flex items-end gap-2'>
                <div>
                    <InputWithLabel
                        label={"Upload Bank Statement "}
                        placeholder={"Enter Upi Id ."}
                        required={true}

                        type={'file'}


                        onChange={(e) => setStatementFile(e.target.files[0])}
                    />
                    <span className={`${message.type === "error" ? 'text-red-800' : 'text-green-500'} `}>{message.message}</span>
                </div>
                <Button text={isVerify ? 'Upload' : "Download"} type={'button'} onClick={handleSubmit} />
            </div>

            {statementData && (
                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>{renderCompanyCard()}</div>
                    <pre className="bg-black relative text-green-500 p-4 rounded text-sm overflow-auto max-h-[600px]">
                        <FaCopy className="absolute top-2 cursor-pointer right-2  bg-white p-1 rounded-md font-bold text-2xl" onClick={() => handleCopyText(statementData)} />
                        {JSON.stringify(statementData, null, 2)}
                    </pre>
                </div>
            )}
        </div>
    );
};

export default BankAccountAnlyscis;
